import { reactive } from "vue";
import { useRoute, useRouter } from "vue-router";
import { UserApi } from "../apis/modules/UserApi.mjs";
import "fx-front-utils";
import { isEmpty } from "lodash-unified";
let userInfo = reactive({});
const tokenKey = "$UCENTER_TOKEN";
function useUser() {
  const route = useRoute();
  const router = useRouter();
  const getToken = () => {
    return localStorage.getItem(tokenKey);
  };
  const setToken = (token) => {
    localStorage.setItem(tokenKey, token);
  };
  const removeToken = () => {
    localStorage.removeItem(tokenKey);
  };
  const setUserInfo = async () => {
    const token = getToken();
    if (!token)
      throw new Error("fx-front-ucenter[useUser]: Can not find token!");
    const res = await UserApi.getUserInfo(token);
    userInfo = res == null ? void 0 : res.data;
  };
  const getUserInfo = async () => {
    if (isEmpty(userInfo)) {
      await setUserInfo();
    }
    return userInfo;
  };
  const logoutAndBackToCurrentPage = (host) => {
    const url = router.resolve({
      name: "Login",
      query: {
        redirect: String(route.name),
        ...route.query
      }
    });
    const loginUrl = encodeURIComponent((host != null ? host : document.location.origin) + url.href);
    logout(loginUrl);
  };
  const logout = async (url) => {
    const token = getToken();
    removeToken();
    const href = token ? UserApi.logout(token, url) : UserApi.getUserCenterUrl(url);
    window.location.href = href;
  };
  const logoutByRequest = async (logoutUrl) => {
    const token = getToken();
    removeToken();
    window.location.href = UserApi.logoutByRequest(token, logoutUrl);
  };
  return {
    getToken,
    setToken,
    removeToken,
    setUserInfo,
    getUserInfo,
    logout,
    logoutByRequest,
    logoutAndBackToCurrentPage
  };
}
export { useUser };
